export class Authorization {
  accessToken: string = 'access-token';
  refreshToken: string = 'refresh-token';
  tokenExpiresInMilliseconds: string = 'tokenExpiresInMilliseconds';
  grantType: string = 'grant_type';
  scope: string = 'scope';
  offlineAccessScope: string = 'offline_access';
  tenantId: string = 'tenantId';
  passwordGrantType: string = 'password';
  refreshTokenGrantType: string = 'refresh_token';
}

export const TimezoneOptions = [
  { label: 'Eastern Time (ET)', value: 'America/New_York' },
  { label: 'Central Time (CT)', value: 'America/Chicago' },
  { label: 'Mountain Time (MT)', value: 'America/Denver' },
  { label: 'Pacific Time (PT)', value: 'America/Los_Angeles' },
  { label: 'Alaska Time (AKT)', value: 'America/Anchorage' },
  { label: 'Hawaii Time (HT)', value: 'America/Honolulu' },
];

export const EnvironmentOptions = [
  { label: 'Test', value: 'Test' },
  { label: 'Production', value: 'Production' },
];

export class Constants {
  public static authorization: Authorization = new Authorization();
}
